import { LOYALTY_LEVEL_NAMES } from '../../constants/levelNames'
import { LoyaltyLevelsTranslations } from '../../translations/LoyaltyLevels.translations'

export const getLevelTranslationKey = (levelName?: string): string | undefined => LoyaltyLevelsTranslations[levelName as LOYALTY_LEVEL_NAMES]
